// src/components/LoadingSpinner.tsx
import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner: React.FC<{ label?: string }> = ({ label }) => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner" />
      {label && <div className="spinner-label">{label}</div>}
    </div>
  );
};

export default LoadingSpinner;
